var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainImgMediaHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272,
    height: 418,
    viewBox: "0 0 272 418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_108",
    "data-name": "\\uC0AC\\uAC01\\uD615 108",
    width: 272,
    height: 418,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-main_img_media_hover"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 418
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_img_media_hover",
    "data-name": "main_img_media hover",
    clipPath: "url(#clip-main_img_media_hover)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_1",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_302",
    "data-name": "\\uADF8\\uB8F9 302"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_104",
    "data-name": "\\uC0AC\\uAC01\\uD615 104",
    width: 272,
    height: 418,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_264",
    "data-name": "\\uADF8\\uB8F9 264",
    transform: "translate(5537.894 -2562.425)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_48",
    "data-name": "\\uD0C0\\uC6D0 48",
    cx: 100.665,
    cy: 19.211,
    rx: 100.665,
    ry: 19.211,
    transform: "translate(-5466.188 2942.801)",
    fill: "#00b5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_217",
    "data-name": "\\uADF8\\uB8F9 217",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -5537.894, 2609.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_216",
    "data-name": "\\uADF8\\uB8F9 216",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_159",
    "data-name": "\\uD328\\uC2A4 159",
    d: "M1226.976,413.783V390.392H1122.384v23.391a53.22,53.22,0,0,0-39.065,51.273V678.287a29.663,29.663,0,0,0,29.662,29.663h123.4a29.663,29.663,0,0,0,29.663-29.663V465.056A53.22,53.22,0,0,0,1226.976,413.783Z",
    transform: "translate(-1083.319 -334.946)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_87",
    "data-name": "\\uC0AC\\uAC01\\uD615 87",
    width: 182.722,
    height: 199.191,
    transform: "translate(0 137.895)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_88",
    "data-name": "\\uC0AC\\uAC01\\uD615 88",
    width: 146.178,
    height: 65.528,
    rx: 18.966,
    transform: "translate(18.272)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "MEDIA_DESIGN",
    "data-name": "MEDIA DESIGN",
    transform: "translate(21.2 255.463)",
    fill: "#161619",
    fontSize: 24,
    fontFamily: "Orbitron-Bold, Orbitron",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MEDIA"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29
  }, "DESIGN")), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_160",
    "data-name": "\\uD328\\uC2A4 160",
    d: "M1292.541,550.159a13.3,13.3,0,0,0-13.3-13.3h0a13.3,13.3,0,0,0-13.3,13.3v22.09h26.6Z",
    transform: "translate(-1132.078 -374.052)",
    fill: "#00b5e5"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "UXUI_Motion_Interaction",
    "data-name": "UXUI / Motion / Interaction",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 99.856, 358.897)",
    fill: "#25acd0",
    fontSize: 12,
    fontFamily: "NotoSans-Regular, Noto Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UXUI / Motion / Interaction")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImgMediaHover);
export default __webpack_public_path__ + "static/media/main_img_media_hover.70f505ee645632445df76757a5a3e7ad.svg";
export { ForwardRef as ReactComponent };